export default "assets/38bb349617c07d0ff3a5ee83a7a0fd76.png";